// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cbia","inner":"styles_inner__2TxxK","right":"styles_right__2HNWc","close":"styles_close__1kYlZ","footer":"styles_footer__30WYE"};